<template>
	<div>
        <div :id="'id'+id" :style="tabulator ? 'height:50px' : ''">
            <b-button v-if="tabulator" v-b-modal="'i-'+ id" variant="link">
                <p>
                    <span v-for="(category, idx) in categories_checked" :key="idx">
                        <b-badge variant="primary">{{categories_obj[category] ? categories_obj[category].name_fr : ""}}</b-badge>&nbsp;
                    </span>
                </p>
           </b-button>
            <div v-else>
                <p>
                    <span v-for="(category, idx) in categories_checked" :key="idx">
                        <b-badge variant="primary">{{categories_obj[category] ? categories_obj[category].name_fr : ""}}</b-badge>&nbsp;
                    </span>
                </p>

                <Tree :edit="edit" @updateNode="updateNode" id="my-tree-id" ref="tree" :custom-options="categories_options" :custom-styles="categories_styles" :nodes="categories"></Tree>            
            </div>
        </div>  
        <b-modal v-if="tabulator" :title="'Catégories'" size="xl" ok-only :id="'i-'+ id" @shown="setTree" @hidden="open = false;">
            <p>
                <span v-for="(category, idx) in categories_checked" :key="idx">
                    <b-badge variant="primary">{{categories_obj[category] ? categories_obj[category].name_fr : ""}}</b-badge>&nbsp;
                </span>
            </p>

            <Tree :edit="edit" @updateNode="updateNode" id="my-tree-id" ref="tree" :custom-options="categories_options" :custom-styles="categories_styles" :nodes="categories"></Tree>
        </b-modal>      
 	</div>
</template>

<script>
    import database from "../services/database.js";
    import store from "../store";

	import Tree from "../../public/js/vuejs-tree/src/components/Tree.vue";
    import uniqueId from "lodash.uniqueid";
    import { type } from 'case';

    var clone = require("clone");

    export default {
        nme: "categorie",
		components: {
            Tree
		},
		props: {
            source: {},
            column: {},
            index: {},
            tabulator: {
                default: true
            },
            categories_prop: {
                default: null
            },
            edit: true
        },
		data() {
			return {
                id: uniqueId(),
                categories_checked: [],
                categories_checked_string: [],
                loaded: 0,
                open: false,
                list: false,

                categories: [],
                categories_obj: {},
                categories_obj_names: {},
                update: false,
                emit_update: false
			};
        },
        computed: {
            categories_styles() {
                return {
                    tree: {
                        height: "auto",
                        maxHeight: "300px",
                        overflowY: "visible",
                        display: "inline-block",
                        textAlign: "left",
                    },
                    row: {
                        style: {
                            width: "500px",
                            cursor: "pointer",
                        },
                        child: {
                            class: "",
                            style: {
                            height: "35px",
                            },
                            active: {
                                style: {
                                    height: "35px",
                                },
                            },
                        },
                    },
                    rowIndent: {
                        paddingLeft: "20px",
                    },
                    text: {
                        // class: "" // uncomment this line to overwrite the 'capitalize' class, or add a custom class
                        style: {},
                        active: {
                            style: {
                                "font-weight": "bold",
                                color: "#2ECC71",
                            },
                        },
                    },
                };
            },
            categories_options() {
                return {
                    treeEvents: {
                        expanded: {
                            state: false,
                        },
                        collapsed: {
                            state: false,
                        },
                        selected: {
                            state: false
                        },
                        checked: {
                            state: true,
                        },
                    },
                    events: {
                        expanded: {
                            state: true,
                        },
                        selected: {
                            state: true,
                        },
                        checked: {
                            state: true
                        },
                        editableName: {
                            state: true,
                            calledEvent: "expanded",
                        },
                    },
                    addNode: {
                        state: false,
                        fn: null,
                        appearOnHover: false,
                    },
                    editNode: { state: false, fn: null, appearOnHover: false },
                    deleteNode: {
                        state: false,
                        fn: null,
                        appearOnHover: true,
                    },
                    showTags: true,
                };
            },
        },
		watch: {
            source() {
                this.update = false;
                this.init();
            },
            categories_checked: {
				deep: true,
				async handler(value, oldValue) {
                    var categories_checked_string = JSON.stringify(this.categories_checked);
                    if (this.emit_update == true && categories_checked_string != this.categories_checked_string)
                    {                        
                        this.$nextTick(() => {
                            this.$emit('update', this.index, this.column, categories_checked_string);
                        });
                    }
                    this.categories_checked_string = categories_checked_string;
                }
            }
		},
		methods: {
            async setTree()
            {
                //console.log("setTree - " + this.update)
                
                var self = this;
                this.emit_update = false;

                if (this.update == false)
                {
                    this.$refs.tree.uncheckAllNodes();
                    this.$refs.tree.collapseAllNodes();

                    for (var i = 0; i < this.categories_checked.length; i++)
                    {
                        this.$refs.tree.checkNode(this.categories_checked[i]);
                        this.$refs.tree.expandNode(this.categories_checked[i]);
                    }

                    this.update = true;
                }
                
				setTimeout(() => {
                    //console.log("setTree - end")
                    self.emit_update = true;
                }, "200");
            },
            async setCategories()
            {
                //console.log("setCategoriesObj");

                this.categories = [];

                if (this.categories_prop)
                    categories = this.categories_prop;
                else
                {
                    var categories = await database.get("select", store.state.client.details.tables_obj.categories, {
                        select: "*",
                        where: "level is not null order by level"
                    });
                }
                
                var categories_obj = {};

                //console.log(categories)

                for (var i = 0; i < categories.length; i++)
                {
                    this.categories_obj[categories[i].id] = categories[i];
                    this.categories_obj_names[categories[i].name_fr] = categories[i];
                    if (categories[i].level == 0)
                    {
                        var nodes = [];
                        this.categories.push({
                            id: categories[i].id,
                            parent: null,
                            text: categories[i].name_fr || categories[i].name || categories[i].es,
                            checkable: true,
                            selectable: false,
                            expandable: true,
                            state: {
                                checked: true,
                                expanded: true,
                                selected: false
                            },
                            nodes: nodes
                        })
                        categories_obj[categories[i].id] = nodes;
                    }
                    else if (categories[i].level > 0 && categories[i].parent_id && categories_obj[categories[i].parent_id])
                    {
                        var nodes = [];
                        categories_obj[categories[i].parent_id].push({
                            id: categories[i].id,
                            parent: categories[i].parent_id,
                            text: categories[i].name_fr || categories[i].name || categories[i].es,
                            checkable: true,
                            selectable: false,
                            expandable: true,
                            state: {
                                checked: false,
                                expanded: false,
                                selected: false
                            },
                            nodes: nodes
                        })
                        categories_obj[categories[i].id] = nodes;
                    }
                }
                //store.commit("setCategories", {categories: this.categories, categories_obj: this.categories_obj, categories_obj_names: this.categories_obj_names});
            },
            updateNode(node)
            {
                var self = this;

                if (node.state.checked)
                {
                    while (node.parent)
                    {
                        if (!this.categories_checked.includes(node.parent))
                        {
                            this.$refs.tree.checkNode(node.parent);
                        }
                        node = this.$refs.tree.findNode(node.parent);
                    }
                }

                if (this.update == true)
                {
                    this.categories_checked = this.$refs.tree.getCheckedNodes("id", false);
                }
            },
            test()
            {
                //console.log("toto")
            },
            async init()
            {
                //console.log("init")

                var self = this;

                this.emit_update = false;
            
                var source = clone(this.source);

                if (!source)
                    source = [];

                //console.log(source)
                //console.log(typeof source)
                if (typeof source == "string")
                {
                    source = JSON.parse(source);
                }

                this.categories_checked = source;

                /*var categories = store.state.categories;
                if (!categories)*/
                    await this.setCategories();
                /*else
                {
                    this.categories = categories.categories;
                    this.categories_obj = categories.categories_obj;
                    this.categories_obj_names = categories.categories_obj_names;
                }*/

                //console.log(self.$refs.tree)

                if (self.$refs.tree)
                {
                    this.setTree();
                }
            }
		},
		mounted: async function () {
            this.init();
		},
	};
</script>

<style>
</style>
